export default "/unterm2/js/webpack/webfonts/Icon material-verified-user.svg";